import { Collapse } from 'bootstrap';

( ( $ ) => {

    $( 'button.menu-toggle' ).on( 'click', ( ev ) => {
        $( '.burger-menu-wrapper' ).toggleClass( 'show-burger-menu' );

        if ( $( '.burger-menu-wrapper' ).hasClass( 'show-burger-menu' ) )
        {
            $( 'button.menu-toggle' ).find( 'i.fa-bars' ).addClass( 'd-none' );
            $( 'button.menu-toggle' ).find( 'i.fa-xmark' ).removeClass( 'd-none' );
            $( 'button.menu-toggle' ).attr('aria-expanded', 'true');
            $( 'button.menu-toggle' ).attr('aria-label', 'Close menu'); 
        }
        else
        {
            $( 'button.menu-toggle' ).find( 'i.fa-bars' ).removeClass( 'd-none' );
            $( 'button.menu-toggle' ).find( 'i.fa-xmark' ).addClass( 'd-none' );
            $( 'button.menu-toggle' ).attr('aria-expanded', 'false');
            $( 'button.menu-toggle' ).attr('aria-label', 'Open menu');
        }
    } );

} )( jQuery );